import React, { useContext, useEffect, useMemo, useState } from 'react'
import styles from "../../../Styles/ComponentStyles/MainPages/Member.module.scss"
import globalStyles from "../../../Styles/global.module.scss"

import Grid from '@mui/material/Grid2';
import { Outlet, useNavigate } from 'react-router-dom';
import GlobalTabs from '../../../Utils/Layout/GlobalTabs/GlobalTabs';
import { members } from '../../../Utils/Constant/Constant';
import { Button, Chip, FormControlLabel, IconButton, InputAdornment, ListItemIcon, ListItemText, Menu, MenuItem, Pagination, PaginationItem, Stack, styled, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from '@mui/material';
import { Search } from '@mui/icons-material';
import GlobalTextfield from '../../../Utils/Layout/GlobalTextfield/GlobalTextfield';
import Icons from '../../../Utils/Layout/Icons/Icons';
import { MemberContext, MemberContextPayload } from '../../../Context/MemberDetailsContext';
import { GlobalUserContext, GlobalUserContextPayload } from '../../../Context/GlobalUserDetailContext';
import agent from '../../../Services/api';
import { useSnackbar } from '../../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
import {
    DataGrid,
    GridToolbar,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector,
    GridToolbarExport,
    GridToolbarFilterButton,

} from '@mui/x-data-grid';
import moment from 'moment';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { UpdateMemberDetailsPayload, UpdateUserStatusByPayloadModel } from '../../../models/memberAxiosModels';
import GlobalWarningDialog from '../../../Utils/Layout/GlobalWarningDialog/GlobalWarningDialog';
import GlobalDialog from '../../../Utils/Layout/GlobalDialog/GlobalDialog';

const IOSSwitch = styled((props: any) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 40,
    height: 22,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#65C466',
                opacity: 1,
                border: 0,
                ...theme.applyStyles('dark', {
                    backgroundColor: '#2ECA45',
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
            ...theme.applyStyles('dark', {
                color: theme.palette.grey[600],
            }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            ...theme.applyStyles('dark', {
                opacity: 0.3,
            }),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 19,
        height: 18,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        ...theme.applyStyles('dark', {
            backgroundColor: '#39393D',
        }),
    },
}));

const Users = () => {

    const {
        memberUserListDetails,
        setMemberUserListDetails,
        setStoredExistingMemberDetails,
        storedExistingMemberDetails
    } = useContext(MemberContext) as MemberContextPayload

    const {
        flagLoader,
        setFlagLoader,
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const { showSnackbar } = useSnackbar();
    const navigate = useNavigate()
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [flagDeleteMemberDialog, setFlagDeleteMemberDialog] = useState(false)

    const columns: any = [
        {
            field: 'email',
            headerName: 'EMAIL',
            flex: 1,
            width: 350,
            minWidth: 350,
            // maxWidth: 400,
            renderCell: (params: any) => {
                const isAdmin = params.row.admin;
                const email = `${params.row?.email}`.trim();
                return (
                    <>
                        <Grid>
                            <Grid container sx={{ alignItems: "center" }}>
                                <Grid>
                                    {email}
                                </Grid>
                                {isAdmin && (
                                    <Grid>
                                        <Chip
                                            label="Admin"
                                            size="small"
                                            color="primary"
                                            sx={{ fontSize: '10px', height: '20px', ml: 1 }}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>

                    </>
                )
            }
        },
        {
            field: 'firstName',
            headerName: 'FULL NAME',
            flex: 1,
            width: 180,
            minWidth: 180,
            // maxWidth: 250,
            renderCell: (params: any) => {
                const fullName = `${params.row.fullName}`.trim();
                return (
                    <Grid container alignItems="center" spacing={1}>
                        <Grid>
                            <Typography variant="body2">{fullName ? fullName : "-"}</Typography>
                        </Grid>
                    </Grid>
                );
            }
        },
        {
            field: 'contact',
            headerName: 'CONTACT',
            flex: 1,
            width: 220,
            minWidth: 220,
        },
        {
            field: 'agencyName',
            headerName: 'AGENCY',
            width: 150,

        },
        {
            field: 'register_in',
            headerName: 'SOURCE',
            flex: 1.2,
            width: 200,
            minWidth: 200,
            maxWidth: 200,
            renderCell: (params: any) => {
                const company = params?.row?.registerIn?.name;

                const getStyles = (companyName: string | undefined) => {
                    switch (companyName) {
                        case 'Brokers Alliance':
                            return {
                                backgroundColor: 'rgba(0, 174, 255, 0.1)',
                                border: '1px solid #00aeff',
                                color: '#00aeff'
                            };
                        case 'Retirement Brain':
                            return {
                                backgroundColor: 'rgba(255, 179, 0, 0.1)',
                                border: '1px solid #ffb300',
                                color: '#ffb300'
                            };
                        case 'Acrylic Financial':
                            return {
                                backgroundColor: 'rgb(205, 141, 141,  0.1)',
                                border: '1px solid #cd8d8d',
                                color: '#ffdfdf'
                            };
                        case 'Brooklight':
                            return {
                                backgroundColor: 'rgb(126, 244, 255, 0.1)',
                                border: '1px solid rgb(126 244 255)',
                                color: 'rgb(126 244 255)'
                            };
                        case 'Life Brain':
                            return {
                                backgroundColor: 'rgb(111, 207, 100, 0.1)',
                                border: '1px solid rgb(111 207 100)',
                                color: 'rgb(111 207 100)'
                            };
                        default:
                            return {
                                backgroundColor: 'transparent',
                                border: '1px solid #ccc',
                                color: 'white'
                            };
                    }
                };

                const styles = getStyles(company);

                return (
                    <div
                        style={{
                            padding: '4px 12px',
                            fontSize: '12px',
                            fontWeight: 500,
                            borderRadius: '15px',
                            display: 'inline-block',
                            textAlign: 'center',
                            ...styles
                        }}
                    >
                        {company || '-'}
                    </div>
                );

            }
        },
        {
            field: 'lastLoginAt',
            headerName: 'LAST LOGIN',
            flex: 1,
            width: 150,
            minWidth: 150,
            maxWidth: 150,
            valueFormatter: (params: any) =>
                params?.value ? moment(params.value).format('MM/DD/YYYY') : '',
        },
        {
            field: 'status_id',
            headerName: 'STATUS',
            flex: 1,
            width: 120,
            minWidth: 120,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params: any) => {
                const status = params.row?.userStatus?.status;
                const isAdmin = params.row?.admin

                if (isAdmin == false && status === 'UnderReview') {
                    return (
                        <Grid
                            sx={{
                                background: 'rgba(255, 255, 255, 0.15)',
                                border: "1px solid white",
                                borderRadius: '15px',
                                fontSize: '11px',
                                fontWeight: '500',
                                padding: "5px 8px"
                            }}
                        >
                            Under Review
                        </Grid>
                    );
                }

                const isChecked = status === 'Active';

                return (
                    <>
                        {isAdmin == false &&
                            <FormControlLabel
                                className={styles.iosSwitch}
                                sx={{ margin: '0px !important' }}
                                label=""
                                control={
                                    <IOSSwitch
                                        sx={{ m: 1 }}
                                        checked={isChecked}
                                        onChange={() =>
                                            handleUserStatus(params.row, isChecked ? 'InActive' : 'Active')
                                        }
                                    />
                                }
                            />
                        }
                    </>
                );
            }
        },
        {
            field: 'action',
            headerName: '',
            minWidth: 50,
            maxWidth: 50,
            align: "right",
            headerAlign: "right",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params: any) => {
                const isAdmin = params.row?.admin
                const row = params?.row
                return (
                    <>
                        {isAdmin == false &&
                            <>
                                <IconButton
                                    onClick={(e) => handleOpenMenu(e, row)}
                                >
                                    <MoreVertIcon sx={{ color: 'white' }} />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    PaperProps={{
                                        style: {
                                            boxShadow: "none",
                                            borderRadius: '5px 0px 5px 5px',
                                        },
                                    }}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                >
                                    <MenuItem
                                        onClick={() => {
                                            handleClose();
                                            if (storedExistingMemberDetails?.userId) {
                                                navigate(`/member/viewUsers?userId=${storedExistingMemberDetails?.userId}`)
                                            }
                                        }}
                                    >
                                        <ListItemIcon><EditIcon fontSize="small" sx={{ color: "black" }} /></ListItemIcon>
                                        <ListItemText>Edit</ListItemText>
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => {
                                            setFlagDeleteMemberDialog(true)
                                            handleClose();
                                        }}
                                    >
                                        <ListItemIcon><DeleteIcon fontSize="small" sx={{ color: "black" }} /></ListItemIcon>
                                        <ListItemText>Delete</ListItemText>
                                    </MenuItem>
                                </Menu>
                            </>
                        }
                    </>
                )
            },
        }
    ];

    const initializeAuth = async () => {
        setFlagLoader(true);
        const response = await agent.getUsersListDetailsApi.get();
        if (response?.status && response?.data) {
            const userResponse = response.data?.users;
            setMemberUserListDetails(userResponse);
            setFlagLoader(false);
        } else {
            setFlagLoader(false);
            const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
        }
    };

    useEffect(() => {
        initializeAuth();
    }, []);

    const paginatedRows = useMemo(() => {
        const data = memberUserListDetails || []; // ensure it's always an array
        const startIndex = (page - 1) * rowsPerPage;
        return data.slice(startIndex, startIndex + rowsPerPage);
    }, [memberUserListDetails, page, rowsPerPage]);

    const handleUserStatus = async (row: any, newStatus: 'Active' | 'InActive') => {
        const payload: UpdateUserStatusByPayloadModel = {
            userId: row.userId ?? "",
            firstName: row.firstName ?? "",
            lastName: row.lastName ?? "",
            contact: row.contact ?? "",
            agencyName: row.agencyName ?? "",
            city: row.city ?? "",
            zipcode: row.zipcode ?? "",
            stateID: row.stateID ?? "",
            addressLine1: row.addressLine1 ?? "",
            addressLine2: row.addressLine2 ?? "",
            affiliated_Brooklight: row.affiliated_Brooklight ?? "",
            affiliated_BA: row.affiliated_BA ?? "",
            profileImage: row.profileImage ?? null,
            status: newStatus,
        };

        try {
            const response = await agent.updateUserStatusApi.put(payload);
            if (response?.status) {
                await initializeAuth();
                const successMessage = response?.message ? response?.message : "Status updated successfully!"
                showSnackbar(successMessage, "success");
            }
            else {
                const error = response?.data?.error?.message || 'Something Went Wrong!'
                showSnackbar(error, "error");
            }
        } catch (error) {
            showSnackbar("Error occurred while updating status", "error");
        }
    };

    const handleOpenMenu = (event: any, row: any) => {
        setAnchorEl(event.currentTarget);
        setStoredExistingMemberDetails(row)
    };

    const handleClose = () => {
        setAnchorEl(null)
    };

    const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    const CustomToolbar = () => (
        <GridToolbarContainer
            sx={{
                color: '#fff',
                marginBottom: '10px',
                '& .MuiButtonBase-root': {
                    color: '#fff',
                    fontWeight: 500,
                    fontSize: '14px',
                    textTransform: 'uppercase',
                },
            }}
        >
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector />
            <GridToolbarExport />
        </GridToolbarContainer>
    );

    const handleDeleteMember = async () => {
        if (storedExistingMemberDetails?.userId) {
            const payload = {
                userId: storedExistingMemberDetails?.userId ?? 0,
                status: "Deleted",
            };

            setFlagLoader(true)
            const response = await agent.updateUserStatusApi.put(payload)
            if (response?.status) {
                console.log("response of updateUserStatusApi", response);
                await initializeAuth()
                const successMessage = response?.message ? response?.message : "User Deleted Successfully!"
                showSnackbar(successMessage, "success");
                setFlagLoader(false)
                setFlagDeleteMemberDialog(false)
            }
            else {
                console.log("response false of updateUserStatusApi", response);
                const successMessage = response?.message ? response?.message : "Something Went Wrong!"
                showSnackbar(successMessage, "error");
                setFlagLoader(false)
                setFlagDeleteMemberDialog(false)
            }
        }
    }

    return (
        <>
            {flagDeleteMemberDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    open={flagDeleteMemberDialog}
                    maxWidth="sm"
                    dialogHead={'Delete Confirmation'}
                    onClose={() => { setFlagDeleteMemberDialog(false) }}
                    view={
                        <GlobalWarningDialog
                            popupDescription={`Are you sure you want delete ${storedExistingMemberDetails?.fullName} Member?`}
                            primaryButtonText={"Delete"}
                            secondaryButtonText={"Cancel"}
                            primaryButtonWidth="175px"
                            secondaryButtonWidth="175px"
                            onDelete={handleDeleteMember}
                            handleClose={() => { setFlagDeleteMemberDialog(false) }}
                        />
                    }
                />
            }

            <Grid container>
                <Grid size={{ xs: 12 }} sx={{ position: 'relative' }}>
                    <Grid container>
                        <Stack className={styles.paginationStack}>
                            <Pagination
                                count={Math?.ceil(memberUserListDetails?.length / rowsPerPage)}
                                page={page}
                                siblingCount={0}
                                boundaryCount={1}
                                onChange={handlePageChange}
                                className={globalStyles.gblPaginationStyles}
                                sx={{ "& .MuiPaginationItem-ellipsis": { color: "black" } }}
                                renderItem={(item) => (
                                    <PaginationItem
                                        {...item}
                                        sx={{
                                            "&.Mui-selected": {
                                                backgroundColor: "#4A6086",
                                                color: "white",
                                                "&:hover": {
                                                    backgroundColor: "#4A6086",
                                                    color: "white",
                                                },
                                            },
                                            backgroundColor: "#ffffff",
                                            borderRadius: "8px",
                                            color: "#000000",
                                            "&:hover": {
                                                backgroundColor: "#ffffff",
                                                color: "#000000",
                                            },
                                        }}
                                    />
                                )}
                            />
                        </Stack>

                        <Grid size={{ xs: 12 }} sx={{ margin: "20px 0px 0px" }}>
                            <DataGrid
                                rows={paginatedRows}
                                columns={columns}
                                autoHeight
                                density='standard'
                                getRowId={(row) => row.userId}
                                className={globalStyles.globalDatagridStyles}
                                // pageSizeOptions={[10, 25, 50]}
                                pagination
                                paginationModel={{ pageSize: 15, page: 0 }}
                                checkboxSelection={false}
                                disableRowSelectionOnClick
                                hideFooterPagination
                                rowHeight={50}
                                columnHeaderHeight={50}
                                slots={{
                                    toolbar: CustomToolbar,
                                }}
                                onPaginationModelChange={(model) => {
                                    setPage(model.page);
                                    setRowsPerPage(model.pageSize);
                                }}
                            />
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default Users